module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av347-217951b4913120c0bdce9aef85073fba.jpg";